import {colors, fontSizes, fonts, shadow, spacings} from 'style';

const style = {
    container: {
        height:'100%', 
        padding:'0px 10px 70px 10px',
        textAlign: 'center',
        ...fonts.body,
        lineHeight: '1.5',
    },
    containerDiv: {
        height:'100%', 
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '40rem'
    },
    segment: {
        overflow: 'auto',
        height: '100%',
        textAlign: 'center',
        paddingTop: '0',
        border: 'none',
        boxShadow: 'none',
    },
    topRow: {
        paddingTop: '0',
        paddingBottom: '0',
    },
    grid: {
        height: '100%',
        paddingTop: '0',
        marginTop: '0',
    },
    imageBanner: {
        marginTop: spacings.base,
        marginBottom: spacings.base,
        borderRadius: spacings.small,
        boxShadow: shadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        height:'260px', 
        width:'100%',
        maxWidth: '522px',
        backgroundSize:'100%',
        backgroundPositionY: 'center',
        backgroundRepeat: 'no-repeat',
    },
    button: {
        backgroundColor: colors.themeBlue,
        color: '#fff',
        height: '70px',
        fontSize: '2em',
        lineHeight: '70px',
        width: '100%',
        position: 'absolute',
        bottom: '0',
        left: '0',
        border: 'none',
        cursor: 'pointer',
    },
    buttonDisabled: {
        backgroundColor: colors.themeDarkGrey,
        color: colors.themeGrey,
        cursor: 'auto',
    },
};

export default style;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/style.js